import React from 'react';
import './EquipmentAccessSharingDialogMyRoleText.less';
import { useTranslation } from 'react-i18next';
import { AccessSharingRole } from 'types/entities/AccessSharingRole';

interface Props {
  role: AccessSharingRole;
}

export default function EquipmentAccessSharingDialogMyRoleText({
  role,
}: Props) {
  const { t } = useTranslation();

  return (
    <span className="equipment-access-sharing-dialog-my-role-text">
      <span className="equipment-access-sharing-dialog-my-role-text__label">
        {t('equipment_page.dialogs.access_sharing_dialog.my_role')}
      </span>

      <span className="equipment-access-sharing-dialog-my-role-text__chip">
        {t(role.toLowerCase()).toUpperCase()}
      </span>
    </span>
  );
}
